import type { ActionTree, GetterTree, MutationTree } from "vuex";

const localState = () => ({
  systemTree: {} as { [keys: number]: any },
  users: [] as any,
  boards: [] as any,
  lastLocale: null as null | string,
  colors: [] as string[],
  lastUsedRoutes: [], // TODO: implement
  eventExport: {
    siteIds: [] as number[],
    boardIds: {} as Record<number, number[]>,
    promises: [] as {
      id: string;
      promise: Promise<any>;
      range: { start: string; end: string };
      resolved: boolean;
    }[],
  },
});

export const getters: GetterTree<ReturnType<typeof localState>, any> = {
  getLastLocale: (state) => state.lastLocale,
  systemTreeState: (state) => state.systemTree,
  getUsers: (state) => state.users,
  getBoards: (state) => state.boards,
  getRecentColorsForColorPicker: (state) => state.colors,
  getEventExportData: (state) => {
    return state.eventExport;
  },
};

const actions: ActionTree<typeof localState, any> = {
  /** eventExport stuff */
  setEventExportConfiguration(context, payload) {
    context.commit("setEventExportConfiguration", payload);
  },
  removeEventExportPromise(context, payload) {
    context.commit("removeEventExportPromise", payload);
  },
  clearEventExportPromise(context, payload) {
    context.commit("clearEventExportPromise", payload);
  },
  updateEventExportPromise(context, payload) {
    context.commit("updateEventExportPromise", payload);
  },
  addEventExportPromise(context, payload) {
    context.commit("addEventExportPromise", payload);
  },
  setRecentColorsForColorPicker(context, payload) {
    context.commit("setRecentColorsForColorPicker", payload);
  },
  setLastLocale(context, payload) {
    context.commit("setLastLocale", payload);
  },
  upsertBoard(context, payload) {
    context.commit("upsertBoard", payload);
  },
  setSystemTreeNode(context, payload) {
    context.commit("setSystemTreeNode", payload);
  },
};

const mutations: MutationTree<ReturnType<typeof localState>> = {
  clearEventExportPromise(state) {
    state.eventExport.promises = [];
  },
  updateEventExportPromise(state, payload) {
    const index = state.eventExport.promises.findIndex((el) => el.id === payload.id);
    if (index > -1) {
      state.eventExport.promises[index] = {
        ...state.eventExport.promises[index],
        ...payload,
      };
    }
  },
  removeEventExportPromise(state, payload) {
    state.eventExport.promises = state.eventExport.promises.filter((el) => el.id !== payload);
  },
  addEventExportPromise(state, payload) {
    state.eventExport.promises.push(payload);
  },
  setEventExportConfiguration(state, payload) {
    state.eventExport.boardIds = payload.boardIds;
    state.eventExport.siteIds = payload.siteIds;
  },
  setRecentColorsForColorPicker(state, payload) {
    state.colors = payload;
  },
  setLastLocale(state, payload) {
    state.lastLocale = payload;
  },
  upsertBoard(state, payload) {
    const board = state.boards.findIndex((el: any) => el.id === payload.id);
    if (board > -1) {
      state.boards[board] = payload;
    } else {
      state.boards.push(payload);
    }
  },
  setUsers(state, payload) {
    payload.forEach((user: any) => {
      const exist = state.users.find((el: any) => el.id === user.id);
      if (exist == null) {
        state.users.push(user);
      }
    });
  },
  setSystemTreeNode(state, newState) {
    if (state.systemTree[newState.id]) {
      state.systemTree[newState.id].isExpanded = newState.isExpanded;
      return;
    }
    state.systemTree[newState.id] = { isExpanded: false };
    state.systemTree[newState.id].isExpanded = newState.isExpanded;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters,
  actions,
  mutations,
};
